import { FC, useState } from "react";
import LogoImages from "../../assets/images/logoSvg.svg";
import ImageContent from "../../assets/images/frame.png";
import { AuthBrandLogo, CoBrandLockup } from "components/AuthBrandLogo";
import { useAppDispatch } from "store";
import { Link, useNavigate } from "react-router-dom";
import { useLoginPassword, useRequestAuthOtp } from "hooks/useAuth";
import { setOtp, setMobile, setAuth, setProfileAndContact } from "store/slices/authSlice";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  Form,
  Grid,
  Input,
  message,
  Row,
  Typography,
} from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { getAuthProfile, requestKeepAlive } from "services/authAPI";
import { getFirebaseToken } from "services";
import { encrypt } from "utils/encryption";
import { loginEncryptionKey } from "config";

const { useBreakpoint } = Grid;

const SignInPage: FC = () => {
  const [isError, setIsError] = useState<boolean>(false);
  const [loginMode, setLoginMode] = useState<string>('phone');
  const [inputValue, setInputValue] = useState<string>("");
  const [userProfile, setUserProfile] = useState<any>(null);
  const [accessToken, setAccessToken] = useState<string>("");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { mutate: requestOtpAuth, isPending } = useRequestAuthOtp();
  const { mutate: loginPassword, isPending: isPendingPassword } = useLoginPassword();

  const [form] = Form.useForm();



  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setIsError(false);
  };


  const handleSubmit = (values: any) => {
    const inputVal = values.input?.trim();

    if (loginMode === 'phone') {
      handleRequestOtp(inputVal);
    } else {
      handlePasswordLogin(inputVal, values.password);
    }
  };

  const handleRequestOtp = (mobile: string) => {

    requestOtpAuth(
      {
        mobile: mobile,
        app_name: "factory",
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            dispatch(setOtp({ token: data.token, refNo: data.ref_no }));
            dispatch(setMobile(mobile));
            navigate("/confirm-otp");
            message.success("ส่งข้อมูลเรียบร้อย");
          } else {
            setIsError(true);
            message.error(` ${data.error_message}`);
          }
        },
        onError: (error) => {
          setIsError(true);
          message.error(
            "ไม่พบเบอร์โทรศัพท์หรืออีเมลนี้ในระบบ กรุณาตรวจสอบอีกครั้ง"
          );
        },
      }
    );
  };

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken) => {
        console.log("Firebase token: ", firebaseToken);
        if (firebaseToken) {
          requestKeepAlive({ fcm_token: firebaseToken });
        }
      })
      .catch((err) =>
        console.error("An error occured while retrieving firebase token. ", err)
      );
  };

  const handlePasswordLogin = (username: string, password: string,) => {
    // console.log("loginEncryptionKey: ", loginEncryptionKey);
    const encryptedPassword = loginEncryptionKey
      ? encrypt(password, loginEncryptionKey)
      : password;

    console.log("encryptedPassword: ", encryptedPassword);

    loginPassword(
      {
        app_name: "factory",
        username: username,
        password: encryptedPassword,
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {

            if (data.profile?.is_verified === false) {

              setUserProfile(data.profile);

              if (data.access_token) {
                setAccessToken(data.access_token);
              }


            } else {

              if (data.access_token) {
                dispatch(setAuth({ access_token: data.access_token }));
              }

              getAuthProfile()
                .then((res) => {
                  if (res.status === "success") {
                    dispatch(
                      setProfileAndContact({
                        profile: res.profile,
                        contact: res.contact,
                      })
                    );

                    //handleGetFirebaseToken();

                    message.success("เข้าสู่ระบบสำเร็จ");

                    navigate("/dashboard");
                  }
                })
                .catch((err: any) => {
                  message.error(`${err}`);
                  dispatch(setAuth({}));
                });
            }
          } else {
            setIsError(true);
            message.error(data?.error_message || "ข้อมูลไม่ถูกต้อง");
          }
        },
        onError: (error) => {
          setIsError(true);
          message.error("ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง");
        },
      }
    );
  };

  return (
    <>
      <div className="" style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
        <div className="">
          <Row gutter={[0, 0]}>
            <Col
              style={{ padding: 0 }}
              xs={{ span: 0 }}
              lg={{ span: 16 }}
              md={{ span: 16 }}
            >
              <BackgroundGradient>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                  <AuthBrandLogo />
                </div>
              </BackgroundGradient>
            </Col>
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 8, offset: 0 }}
              md={{ span: 8 }}
              style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100vh" }}
            >
              {/* โลโก้ร่วม แบ่งเบา ✕ SME อวดดี — วางฝั่งขวา (คอลัมน์ฟอร์ม) ด้วย เพราะแผงซ้ายซ่อนบนมือถือ */}
              <CoBrandLockup />
              <SectionText>
                <Typography.Title level={4}>ยินดีต้อนรับผู้ประกอบการ</Typography.Title>
              </SectionText>
              <SectionText>
                <Typography.Text>เข้าสู่ระบบแบ่งเบา</Typography.Text>
              </SectionText>
              {isError && (
                <SectionText>
                  <Typography.Text type="danger">
                    ไม่พบเบอร์โทรศัพท์หรืออีเมลนี้ในระบบ กรุณาตรวจสอบอีกครั้ง
                    หรือส่งข้อมูลเพื่อสมัครใช้งานได้ที่{" "}
                  </Typography.Text>
                </SectionText>
              )}
              <SectionInput
                style={{ marginTop: 20 }}
              >
                <Form
                  onFinish={handleSubmit}
                  layout="vertical"
                  className="row-col"
                  form={form}
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  {/* <Form.Item
                    className="username"
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกหมายเลขโทรศัพท์",
                      },
                    ]}
                  >
                    <Input placeholder="เบอร์โทรศัพท์" />
                  </Form.Item> */}

                  <Form.Item
                    className="username"
                    name="input"
                    rules={[
                      {
                        required: true,
                        message: loginMode === 'phone' ? "กรุณากรอกหมายเลขโทรศัพท์" : "กรุณากรอก email",
                      },
                      ...(loginMode === 'email' ? [{
                        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "กรุณากรอก email ที่ถูกต้อง",
                      }] : [{
                        pattern: /^[0-9]{10}$/,
                        message: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
                      }])
                    ]}
                  >
                    <Input
                      placeholder={loginMode === 'phone' ? "เบอร์โทรศัพท์" : "Email"}
                      autoComplete="off"
                      onChange={handleInputChange}
                      value={inputValue}

                    />
                  </Form.Item>

                  {loginMode === 'email' && (
                    <>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกรหัสผ่าน",
                          },
                        ]}
                      >
                        <Input.Password
                          size="small"
                          placeholder="รหัสผ่าน"
                          autoComplete="off"
                          iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                        />
                      </Form.Item>

                    </>
                  )}

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%" }}
                      loading={isPending}
                      size="large"
                    >
                      เข้าสู่ระบบ
                    </Button>
                  </Form.Item>
                </Form>

                {loginMode === 'email' && (
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: -8 }}>
                  <Link to="/resend-verify-email" style={{ color: "#1890ff", textDecoration: "underline" }}>ยังไม่ได้รับอีเมลยืนยัน?</Link>
                  <Link to="/forgot-password" style={{ color: "#1890ff", textDecoration: "underline" }}>ลืมรหัสผ่าน?</Link>
                </div>
                )}
                
                <DividerSection>
                  <DividerLine />
                  <DividerText>หรือ</DividerText>
                  <DividerLine />
                </DividerSection>

                <Form.Item style={{ marginTop: 16 }}>
                  <Button
                    type="default"
                    style={{ width: "100%" }}
                    size="large"
                    onClick={() => {
                      setLoginMode(loginMode === 'phone' ? 'email' : 'phone');
                      setInputValue('');
                      setIsError(false);
                      form.setFieldsValue({
                        input: loginMode === 'email' ? '' : undefined,
                        password: loginMode === 'email' ? undefined : '',
                      });
                      form.validateFields(['input', 'password']);
                    }}
                  >
                    {loginMode === 'phone' ? 'เข้าสู่ระบบด้วย Email' : 'เข้าสู่ระบบด้วยเบอร์โทรศัพท์'}
                  </Button>
                </Form.Item>


              </SectionInput>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default SignInPage;

const MainSection = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
`;

const SectionText = styled.div`
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding: 0 5px;
`;

const ImageSection = styled.div`
  margin-top: 50px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;

const SectionFooter = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px 0;
  text-align: center;
`;

const BackgroundGradient = styled.div`
  background: linear-gradient(45deg, #2777c8, #fff);
  width: 100%;
  height: 100vh;
`;

const NavOnBackground = styled.div`
  position: absolute;
  top: 0;
  left: 20;
  padding: 10px;
`;

const WrapperImageContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: 15%;
`;

const WrapperTextContent = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  margin-top: 6%;
  margin-left: 10%;
  z-index: 1;
`;

const WrapperTextHeader = styled.div`
  margin-left: 100px;
  margin-top: 100px;
`;

const WrapperTextBody = styled.div`
  margin-left: 120px;
  margin-top: 20px;
`;

const DividerSection = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 8px 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #d9d9d9;
`;

const DividerText = styled.span`
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
`;
